import { jsx as r, jsxs as d } from "react/jsx-runtime";
import { u as g, C as u } from "../sortable.esm-c91ac06a.js";
import { Row as n, Col as p } from "antd";
import h from "./SortHandle.js";
import { u as e } from "../styled-components.browser.esm-3eb04950.js";
const D = ({ id: t, containerStyle: i, children: s }) => {
  const {
    attributes: a,
    listeners: l,
    setNodeRef: m,
    transform: c,
    transition: f,
    isDragging: o
  } = g({ id: t });
  return /* @__PURE__ */ r(n, { ref: m, style: {
    transform: u.Transform.toString(c),
    transition: f,
    touchAction: "none",
    ...i
  }, children: /* @__PURE__ */ d(S, { $isdragging: o ? 1 : 0, align: "middle", children: [
    /* @__PURE__ */ r(x, { span: 1, children: /* @__PURE__ */ r(h, { id: `${t}`, ...a, ...l, isDragging: o ? 1 : 0 }) }),
    s
  ] }) });
}, x = e(p)`
    max-height: 40px;
    display: flex;
    flex-direction: column;
    justify-content: center;
`, S = e(n)`
    opacity: ${({ $isdragging: t }) => t ? "0" : "1"};
    width: 100%;
`;
export {
  D as default
};
//# sourceMappingURL=SortableItem.js.map
